<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <base-material-card
      inline
      icon="mdi-view-dashboard"
      title="Rollout dashboard"
    >
        <empty-space></empty-space>
        <p>Dashboard is work in progress</p>
    </base-material-card>
  </v-container>
</template>

<script>
  import Card from '@/components/base/Card'
  import EmptySpace from '@/components/EmptySpace'
  export default {
    name: 'DashboardDashboard',
    components: { EmptySpace, Card },
    data () {
      return {
      }
    },

    computed: {
      totalSales () {
        return this.sales.reduce((acc, val) => acc + val.salesInM, 0)
      },
    },

    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      },
    },
  }
</script>
